import { render, staticRenderFns } from "./zdzggForm.vue?vue&type=template&id=e056d6b0&scoped=true"
import script from "./zdzggForm.vue?vue&type=script&lang=js"
export * from "./zdzggForm.vue?vue&type=script&lang=js"
import style0 from "./zdzggForm.vue?vue&type=style&index=0&id=e056d6b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e056d6b0",
  null
  
)

export default component.exports